
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/fulfillmentPolicy",
      function () {
        return require("private-next-pages/legal/fulfillmentPolicy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/fulfillmentPolicy"])
      });
    }
  